// 高德坐标系转换为百度坐标系
const GDMapToBDMap = ({ lng, lat }) => {
	const xPI = (Math.PI * 3000.0) / 180.0;
	const x = lng;
	const y = lat;
	const z = Math.sqrt(x * x + y * y) + 0.00002 * Math.sin(y * xPI);
	const theta = Math.atan2(y, x) + 0.000003 * Math.cos(x * xPI);
	const lngs = z * Math.cos(theta) + 0.0065;
	const lats = z * Math.sin(theta) + 0.006;

	return {
		lng: lngs,
		lat: lats
	};
};

// 百度坐标系转换为高德坐标系
const BDMapToGDMap = ({ lng, lat }) => {
	const xPI = (Math.PI * 3000.0) / 180.0;
	const x = lng - 0.0065;
	const y = lat - 0.006;
	const z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * xPI);
	const theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * xPI);
	const lngs = z * Math.cos(theta);
	const lats = z * Math.sin(theta);

	return {
		lng: lngs,
		lat: lats
	};
};

export { GDMapToBDMap, BDMapToGDMap };
